import { combineReducers } from 'redux';
import configureStore from './CreateStore';
import rootSaga from '../Sagas/index';
import { routerReducer } from 'react-router-redux';

export default () => {
    /* ------------- Assemble The Reducers ------------- */
    const rootReducer = combineReducers({
        search: require('./Search').reducer,
        full_search: require('./FullSearch').reducer,
        news_letter: require('./NewsLetter').reducer,
        // router
        routing: routerReducer,
    });
    return configureStore(rootReducer, rootSaga);
};
